import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { LotteryMenuPage } from './lottery-menu-page';
import { LotteryMenuComponent } from '../lottery-menu/lottery-menu';
import { BaselineSharedModule } from 'baseline-lib';
import { ProfileModule } from '../../profile/profile.module';

@NgModule({
  declarations: [
    LotteryMenuComponent,
    LotteryMenuPage,
  ],
  imports: [
    BaselineSharedModule,
    ProfileModule,
    IonicPageModule.forChild(LotteryMenuPage),
  ],
  exports:[
    LotteryMenuComponent,
    LotteryMenuPage
  ]
})
export class LotteryMenuPageModule {}



// WEBPACK FOOTER //
// ./src/app/lottery/lottery-menu-page/lottery-menu-page.module.ts